'use strict'

import ObjectCardWrapper from '../../components/Card/ObjectCardWrapper.vue'
import { axiosGet, axiosPost } from '../../axios/axios.js'

export function checkVehicleGroupTypeManagementAccess (user) {
  // return user.hasRole('admin') && user.fullAccess || user.hasOperation('vehicleProvisionApproval')
  return user.hasOperation('vehicleProvisionManagement') || checkVehicleGroupTypeApprovalAccess(user)
}

export function checkVehicleGroupTypeApprovalAccess (user) {
  // return user.hasRole('admin') && user.fullAccess || user.hasOperation('vehicleProvisionApproval')
  return user.hasOperation('vehicleProvisionApproval')
}

export function createVehicleGroupType (target, createConfig, onCreated) {
  const objectParams = createConfig && createConfig.objectParams || {}

  const dialog = target.$d.dialog(target).show({
    maximizedOnNarrow: true,
    persistent: true,
    noWrap: true,
    contentWidth: 800,
    contentComponent: ObjectCardWrapper,
    contentProps: {
      objectId: -1,
      objectType: 'vehicleGroupType',
      objectParams: objectParams,
      subtypeKey: 'fenceCategory',
      create: true,
      createConfig: createConfig,
      modeCustom: true
    },
    componentHandlers: {
      created: (objectId) => {
        console.log('Создан объект, id=', objectId)

        if (onCreated) {
          onCreated(objectId)
        }
        dialog.hide()
      },
      saved: () => {}, // не будет, т.к. закрываем в created
      close: () => {
        dialog.hide()
      }
    }
  })
}

export function removeVehicleGroupType (target, objectRecord, onApplied) {
  const objectId = objectRecord.id

  const urlParams = new URLSearchParams()
  urlParams.set('objectId', objectId)

  target.$q.loading.show({ spinnerColor: 'blue-11' })
  axiosGet({
    url: '/service/delta/vehicleGroupType/checkDeletable?' + urlParams.toString(),
    onSuccess: (response) => {
      return response.data.result
    },
    onFailure: 'Ошибка проверки объекта',
    msgTarget: target,
    throws: true
  }).finally(() => {
    target.$q.loading.hide()
  }).then(result => {
    const warnings = []
    const buttons = []

    if (result.actual) {
      warnings.push('Тип актуален' + (result.approved ? '.' : ', но не утвержден.'))
    } else {
      warnings.push('Тип неактуален.')
    }
    if (result.deletable) {
      warnings.push('Тип не был использован и может быть удален.')
    } else {
      warnings.push('Тип не может быть удален, так как уже был использован.')
    }

    if (result.deletable || result.actual) {
      if (result.deletable) {
        buttons.push({ key: 'delete', name: 'Удалить', color: 'red' })
      }
      if (result.actual) {
        buttons.push({ key: 'setNotActual', name: 'Снять актуальность', color: 'blue' })
      }
      buttons.push({ key: 'cancel', name: 'Отмена', emitable: true, onEscape: true })
    } else {
      buttons.push({ key: 'cancel', name: 'Понятно', emitable: true, onEscape: true })
    }

    target.$d_ask({
      callback: (data, action) => {
        if (action === 'delete') {
          deleteVehicleGroupType(target, objectId)
            .then(() => {
              if (onApplied) {
                onApplied('deleted')
              }
            })
        } else if (action === 'setNotActual') {
          setVehicleGroupTypeNotActual(target, objectId)
            .then(() => {
              if (onApplied) {
                onApplied('setNotActual')
              }
            })
        }
      },
      warning: warnings,
      buttons: buttons
    })
  })
}

function deleteVehicleGroupType (target, objectId) {
  return processVehicleGroupTypeRemoveAction({
    target,
    objectId,
    url: '/service/delta/vehicleGroupType/delete',
    successMessage: 'Объект успешно удален',
    errorMessage: 'Ошибка удаления объекта'
  })
}

function setVehicleGroupTypeNotActual (target, objectId) {
  return processVehicleGroupTypeRemoveAction({
    target,
    objectId,
    url: '/service/delta/vehicleGroupType/setNotActual',
    successMessage: 'Актуальность успешно снята',
    errorMessage: 'Ошибка снятия актуальности объекта'
  })
}

function processVehicleGroupTypeRemoveAction ({ target, objectId, url, successMessage, errorMessage }) {
  const bodyFormData = new FormData()
  bodyFormData.set('objectId', objectId)

  target.$q.loading.show({ spinnerColor: 'blue-11' })
  return axiosPost({
    url: url,
    data: bodyFormData,
    onSuccess: (response) => {
      target.$q.notify({
        type: 'positive',
        message: successMessage,
        progress: true,
        timeout: 3000
      })
    },
    onFailure: (response) => {
      const message = response.message || errorMessage
      target.$q.notify({
        type: 'negative',
        message: message,
        progress: true,
        timeout: 5000
      })
      throw new Error(message)
    }
  }).finally(() => {
    target.$q.loading.hide()
  })
}
